import { render, staticRenderFns } from "./grouponWeappAttr.vue?vue&type=template&id=24ffb607&scoped=true"
import script from "./grouponWeappAttr.vue?vue&type=script&lang=js"
export * from "./grouponWeappAttr.vue?vue&type=script&lang=js"
import style0 from "./grouponWeappAttr.vue?vue&type=style&index=0&id=24ffb607&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ffb607",
  null
  
)

component.options.__file = "grouponWeappAttr.vue"
export default component.exports